import { FC } from "react";

import { Row } from "@hightouch/htui";
import { SortVerticalIcon } from "src/ui/icons";

type SortIcon = {
  className?: string;
  sortDirection?: string | null;
  isHovered: boolean;
};

export const SortIcon: FC<SortIcon> = ({
  sortDirection,
  isHovered,
  ...props
}) => {
  let opacity = [0, 0] as [number, number];

  if (sortDirection?.startsWith("asc")) {
    opacity = [1, 0.5];
  } else if (sortDirection?.startsWith("desc")) {
    opacity = [0.5, 1];
  } else if (isHovered) {
    opacity = [0.5, 0.5];
  } else {
    opacity = [0, 0];
  }

  return (
    <Row align="center" ml={1} borderRadius="md" {...props}>
      <SortVerticalIcon
        leftOpacity={opacity[0]}
        rightOpacity={opacity[1]}
        size={16}
      />
    </Row>
  );
};
